import React from 'react';
import { Shield, Twitter, Linkedin, Facebook, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 border-t border-gray-800" data-id="element-46">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-48">
          <div className="col-span-1 md:col-span-2" data-id="element-49">
            <div className="flex items-center" data-id="element-50">
              <Shield className="h-8 w-8 text-red-500" data-id="element-51" />
              <span className="ml-2 text-xl font-bold text-white" data-id="element-52">
                Pentforce
              </span>
            </div>
            <p className="mt-4 text-gray-400 max-w-md" data-id="element-53">
              Professional penetration testing services to help organizations
              identify and address security vulnerabilities before they can be
              exploited.
            </p>
            <div className="mt-6 flex space-x-6" data-id="element-54">
              <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-55">
                <Twitter className="h-5 w-5" data-id="element-56" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-57">
                <Facebook className="h-5 w-5" data-id="element-58" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-59">
                <Linkedin className="h-5 w-5" data-id="element-60" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-61">
                <Github className="h-5 w-5" data-id="element-62" />
              </a>
            </div>
          </div>
          <div data-id="element-63">
            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase" data-id="element-64">
              Services
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-67">
                  Web App Testing
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-69">
                  Network Testing
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-71">
                  Mobile App Testing
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-73">
                  API Security
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-75">
                  Cloud Security
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-76">
            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase" data-id="element-77">
              Company
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-78">
              <li data-id="element-79">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-80">
                  About Us
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-82">
                  Careers
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-84">
                  Blog
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-86">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-87">
                <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-88">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-89">
          <p className="text-gray-400 text-sm" data-id="element-90">
            &copy; {new Date().getFullYear()} Pentforce. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0" data-id="element-91">
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Pci_dss_compliant.svg" alt="PCI DSS Compliant" className="h-8" data-id="element-92" />
          </div>
        </div>
      </div>
    </footer>;
}